export const Marquee = () => {
  const text = "INTELLIGENZA ARTIFICIALE • INSTAGRAM MARKETING • AUTOMAZIONE • PROCESSI AZIENDALI • ";
  return (
    <section className="overflow-hidden border-y border-[#27272a] bg-black py-6" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <span
            key={k}
            className="px-4 text-sm font-semibold uppercase tracking-[0.2em] text-[#71717a]"
          >
            {text.repeat(4)}
          </span>
        ))}
      </div>
    </section>
  );
};
